const config = require('./store-locator-config');
const templates = require('./store-locator-templates');
const utils = require('./store-locator-utils');

const { StoreFinder } = require('@/commons/component/store-finder');

module.exports.init = function(state, dataSource) {
  const storeFinder = new StoreFinder({
    container: cube.$('.decathlon-woosmap-store-locator-map .store-selection'),
    template: 'store-locator',
  });

  // Create Real GoogleMap item
  const map = new window.google.maps.Map(woosmap.$('#my-map')[0], {
    center: {
      lat:
        cube.ui.isMobile() && cube.env.country === 'FR'
          ? parseFloat(config.centerLat) - 1
          : config.centerLat,
      lng:
        cube.ui.isMobile() && cube.env.country === 'FR'
          ? parseFloat(config.centerlng) + 4
          : config.centerlng,
    },
    zoom: cube.ui.isMobile() ? config.zoom - 0.5 : config.zoom,
    zoomControl: true,
    mapTypeControl: false,
    fullscreenControl: false,
    scaleControl: true,
    styles: config.mapStyle,
  });

  // Associate GoogleMap item in a Woosmap.TiledView
  const mapView = new woosmap.TiledView(map, {
    style: config.markersStyle,
    tileStyle: config.tilesStyle,
  });

  mapView.padding = {
    left: 150 + 12,
  };

  const renderer = new woosmap.TemplateRenderer(templates.infobox);

  const infoBoxOptions = {
    disableAutoPan: false,
    pixelOffset: new google.maps.Size(-140, -300),
    boxClass: 'infoBox',
    closeBoxMargin: '8px',
    closeBoxURL: '/assets/images/woosmap-infobox-close-white.svg',
    infoBoxClearance: {
      width: 1,
      height: 1,
    },
  };

  const locatorWindow = new woosmap.LocatorWindow(
    map,
    renderer,
    infoBoxOptions
  );

  // On opening : set the '#infobox-itinerary' link's href
  locatorWindow.setOpeningCallback(() => {
    $('.woosmap-infobox__store-pagelink').on('click', function(e) {
      // Avoid scoll to top
      e.cancelBubble = true;
      e.preventDefault();
      e.stopPropagation();

      // Get STORE ID in clicked link
      const link = $(this);
      const storeId = link.data('store-id');

      // Get the 'real' link to the store (in bottom cartridge)
      const realStoreLink = $(`.st-l-wrapper a[href*="${storeId}"]`);

      // If real link is present : redirect to real destination
      if (realStoreLink.length) document.location = realStoreLink.attr('href');
    });

    // bind click on 'get direction'
    $(
      '.woosmap-infobox__store-directions, .result_search-box .icon-directions'
    ).on('click', utils.displayTravelBox(state));
    // bind click on 'close direction'
    $('.woosmap-travel-close').on('click', utils.displaySearchBox);

    // get selection
    const { geometry } = locatorWindow.get('selectedStore');
    if (!geometry) return; // exit if no geometry

    const [lat, lng] = geometry.coordinates;
    if (!lat || !lng) return; // exist if not coordinates

    map.panTo(new window.google.maps.LatLng(lng, lat));
  });

  locatorWindow.bindTo('selectedStore', mapView);

  //click on Store
  // Woosmap Markers Options
  mapView.marker.setOptions({ draggable: true });

  // registerLocationClickEvent
  const selectedStoreObserver = new woosmap.utils.MVCObject();
  selectedStoreObserver.selectedStore = null;
  selectedStoreObserver.selectedStore_changed = function() {
    // bind click on 'get direction'
    $(
      '.woosmap-infobox__store-directions, .result_search-box .icon-directions'
    ).on('click', utils.displayTravelBox(state));
    // bind click on 'close direction'
    $('.woosmap-travel-close').on('click', utils.displaySearchBox);

    const selectedStore = this.get('selectedStore');
    let storeId = null;

    if (selectedStore && selectedStore.properties)
      storeId = selectedStore.properties.store_id;

    //StoreID on session
    if (storeId) {
      const realStoreLink = $(`.st-l-wrapper a[href*=${storeId}]`);

      // If real link is present : redirect to real destination
      if (realStoreLink.length)
        $('.woosmap-infobox__store-pagelink').prop(
          'href',
          realStoreLink.attr('href')
        );

      $.ajax({
        url: `/${
          config.language
        }/ajax/rest/model/atg/userprofiling/ProfileActor/setNavigationLocationId?navigationLocationId=${storeId}`,
        data: {},
      });
    }
  };
  selectedStoreObserver.bindTo('selectedStore', mapView);

  const goToPosition = ({ latitude, longitude }) => {
    const newPosition = new window.google.maps.LatLng(latitude, longitude);
    map.setZoom(10);
    map.panTo(newPosition);
  };

  // when store-finder recieve a new stores list
  // go to first one coordinates and close previous popin (if any)
  storeFinder.on('stores', stores => {
    const [longitude, latitude] = stores[0].geometry.coordinates;
    locatorWindow.set('selectedStore', stores[0]);
    storeFinder.seeMoreStores(10);
    goToPosition({ latitude, longitude });
  });
  storeFinder.on(
    'click',
    '.store-selection__cta-zone',
    ({ geometry, store: properties }) => {
      // Reconstruct a 'store' object
      const store = { geometry, properties };
      // Set as 'selectedStore'
      locatorWindow.set('selectedStore', store);
      const [longitude, latitude] = geometry.coordinates;
      goToPosition({ latitude, longitude });
    }
  );

  woosmap.$('.decathlon-woosmap-show-all-stores').click(() => {
    $(window).scrollTo($('.storelist'), 1200, {
      offset: -66,
    });
  });

  woosmap.$('.store-selection__search-form .js-input').click(e => {
    $(e.target).select();
  });

  // "Exports" map & mapView in 'state'
  state.map = map;
  state.mapView = mapView;
};



// WEBPACK FOOTER //
// ./src/modules-es5/pages/store-locator/store-locator-woosmap.js